/**
 * Personalisation du "contextPad" de bpmn-js : le menu qui s'affiche quand on clique sur un élément.
 */
export default class CustomContextPad {
  constructor(config, contextPad, create, elementFactory, injector, translate) {
    this.create = create;
    this.elementFactory = elementFactory;
    this.translate = translate;

    if (config.autoPlace !== false) {
      this.autoPlace = injector.get('autoPlace', false);
    }

    contextPad.registerProvider(this);
  }

  getContextPadEntries(element) {
    const {
      autoPlace,
      create,
      elementFactory,
      translate
    } = this;

    // console.log(element.type);
    if (element.type === 'bpmn:EndEvent' // Pas d'élément après un événement de fin
      || element.type === 'bpmn:SequenceFlow' // ou une flèche
      || element.type === 'label' // ou un label
    ) {
      return; 
    }

    function appendSendTask(event, element) {
      if (autoPlace) {
        const shape = elementFactory.createShape({ type: 'bpmn:SendTask' });
        autoPlace.append(element, shape);
      } else {
        appendSendTaskStart(event, element);
      }
    }

    function appendSendTaskStart(event) {
      const shape = elementFactory.createShape({ type: 'bpmn:SendTask' });
      create.start(event, shape, element);
    }

    function appendUserTask(event, element) {
      if (autoPlace) {
        const shape = elementFactory.createShape({ type: 'bpmn:UserTask' });
        autoPlace.append(element, shape);
      } else {
        appendUserTaskStart(event, element);
      }
    }

    function appendUserTaskStart(event) {
      const shape = elementFactory.createShape({ type: 'bpmn:UserTask' });
      create.start(event, shape, element);
    }

    function appendServiceTask(event, element) {
      if (autoPlace) {
        const shape = elementFactory.createShape({ type: 'bpmn:ServiceTask' });
        autoPlace.append(element, shape);
      } else {
        appendServiceTaskStart(event, element);
      }
    }

    function appendServiceTaskStart(event) {
      const shape = elementFactory.createShape({ type: 'bpmn:ServiceTask' });
      create.start(event, shape, element);
    }

    return (entries) => {
      entries['append.send-task'] = {
        group: 'model',
        className: 'bpmn-icon-send-task',
        title: translate('Append send task'),
        action: {
          click: appendSendTask,
          dragstart: appendSendTaskStart
        }
      };

      entries['append.user-task'] = {
        group: 'model',
        className: 'bpmn-icon-user-task',
        title: translate('Append user task'),
        action: {
          click: appendUserTask,
          dragstart: appendUserTaskStart
        }
      };

      entries['append.service-task'] = {
        group: 'model',
        className: 'bpmn-icon-service-task',
        title: translate('Append service task'),
        action: {
          click: appendServiceTask,
          dragstart: appendServiceTaskStart
        }
      };

      delete entries['append.intermediate-event'];

      return entries;
    };
  }
}

CustomContextPad.$inject = [
  'config',
  'contextPad',
  'create',
  'elementFactory',
  'injector',
  'translate'
];